import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { styled, createTheme, ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import MuiDrawer from '@mui/material/Drawer';
import Box from '@mui/material/Box';
import MuiAppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import List from '@mui/material/List';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import Badge from '@mui/material/Badge';
import Container from '@mui/material/Container';
import MenuIcon from '@mui/icons-material/Menu';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import NotificationsIcon from '@mui/icons-material/Notifications';
import { mainListItems, secondaryListItems } from '../listItems';
import { Link, useNavigate } from 'react-router-dom';
import LogoutIcon from '@mui/icons-material/Logout';

import {
    TextField, Button, Table, TableBody, TableCell, TableContainer,
    TableHead, TableRow, Paper, TablePagination
} from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';

const drawerWidth = 240;

const AppBar = styled(MuiAppBar, {
    shouldForwardProp: (prop) => prop !== 'open',
})(({ theme, open }) => ({
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(['width', 'margin'], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
    }),
    ...(open && {
        marginLeft: drawerWidth,
        width: `calc(100% - ${drawerWidth}px)`,
        transition: theme.transitions.create(['width', 'margin'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),
    }),
}));

const Drawer = styled(MuiDrawer, { shouldForwardProp: (prop) => prop !== 'open' })(
    ({ theme, open }) => ({
        '& .MuiDrawer-paper': {
            position: 'relative',
            whiteSpace: 'nowrap',
            width: drawerWidth,
            transition: theme.transitions.create('width', {
                easing: theme.transitions.easing.sharp,
                duration: theme.transitions.duration.enteringScreen,
            }),
            boxSizing: 'border-box',
            ...(!open && {
                overflowX: 'hidden',
                transition: theme.transitions.create('width', {
                    easing: theme.transitions.easing.sharp,
                    duration: theme.transitions.duration.leavingScreen,
                }),
                width: theme.spacing(7),
                [theme.breakpoints.up('sm')]: {
                    width: theme.spacing(9),
                },
            }),
        },
    }),
);

const mdTheme = createTheme();

export default function EDevice() {

    const navigate = useNavigate();


    const user = JSON.parse(localStorage.getItem('user'));

    if (user) {
        const role = user.role;
        console.log('Role:', role);

    } else {
        console.log('No user data found in session storage');
    }



    const [open, setOpen] = React.useState(true);
    const [devices, setDevices] = useState([]);
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [form, setForm] = useState({
        deviceName: '',
        price: '',
        color: '',
        shopName: '',
        modelNumber: '',
        storage: '',
        ram: '',
        warrenty: '',
        emiNumber: '',
        purchaseDate: '',
        imageName: ''
    });

    // Search filters state
    const [searchDeviceDeviceName, setSearchDeviceDeviceName] = useState('');
    const [searchDevicePrice, setSearchDevicePrice] = useState('');
    const [searchDeviceColour, setSearchDeviceColour] = useState('');
    const [searchDeviceShopName, setSearchDeviceShopName] = useState('');
    const [searchDeviceModelNumber, setSearchDeviceModelNumber] = useState('');
    const [searchDeviceEmiNumber, setSearchDeviceEmiNumber] = useState('');
    const [searchDeviceDateFrom, setSearchDeviceDateFrom] = useState('');
    const [searchDeviceDateTo, setSearchDeviceDateTo] = useState('');
    const [filteredDevices, setFilteredDevices] = useState([]);

    const handleDelete = async (id, emiNumber) => {
        try {
            await axios.delete(`https://app.smartco.live/device/deleteDevice/${id}`);
            await axios.delete(`https://app.smartco.live/inventory/deleteInventoryemi/${emiNumber}`);
            alert("Dervice record deleted successfully");
            fetchDevices();// Refresh the selling list after deletion
        } catch (error) {
            console.error('Error deleting selling:', error);
            alert("An error occurred while deleting the selling record.");
        }
    };

    useEffect(() => {
        fetchDevices();
    }, []);

    const handleLogout = () => {
        // Remove user details from session storage
        localStorage.removeItem('user');
        localStorage.removeItem('token');
        console.log('User details cleared from session storage');
        navigate('/');
    };

    const toggleDrawer = () => {
        setOpen(!open);
    };

    const fetchDevices = async () => {
        try {
            const response = await axios.get('https://app.smartco.live/device/getDevice');
            setDevices(response.data);
        } catch (error) {
            console.error('Error fetching devices:', error);
        }
    };

    const handleInputChange = (event) => {
        const { name, value } = event.target;
        setForm({ ...form, [name]: value });
    };

    const handleFileChange = (event) => {
        setForm({ ...form, imageName: event.target.files[0] });
    };

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    // Search/Filter function for devices
    const handleSearchDevices = () => {
        let filtered = [...devices];

        // Filter by Device Name
        if (searchDeviceDeviceName.trim()) {
            filtered = filtered.filter((device) =>
                device.deviceName.toLowerCase().includes(searchDeviceDeviceName.toLowerCase())
            );
        }

        // Filter by Price
        if (searchDevicePrice.trim()) {
            filtered = filtered.filter((device) =>
                device.price.toString().includes(searchDevicePrice)
            );
        }

        // Filter by Colour
        if (searchDeviceColour.trim()) {
            filtered = filtered.filter((device) =>
                device.color.toLowerCase().includes(searchDeviceColour.toLowerCase())
            );
        }

        // Filter by Shop Name
        if (searchDeviceShopName.trim()) {
            filtered = filtered.filter((device) =>
                device.shopName.toLowerCase().includes(searchDeviceShopName.toLowerCase())
            );
        }

        // Filter by Model Number
        if (searchDeviceModelNumber.trim()) {
            filtered = filtered.filter((device) =>
                device.modelNumber.toLowerCase().includes(searchDeviceModelNumber.toLowerCase())
            );
        }

        // Filter by EMI Number
        if (searchDeviceEmiNumber.trim()) {
            filtered = filtered.filter((device) =>
                device.emiNumber.toLowerCase().includes(searchDeviceEmiNumber.toLowerCase())
            );
        }

        // Filter by Date Range
        if (searchDeviceDateFrom) {
            filtered = filtered.filter((device) => {
                const deviceDate = new Date(device.purchaseDate);
                const fromDate = new Date(searchDeviceDateFrom);
                return deviceDate >= fromDate;
            });
        }

        if (searchDeviceDateTo) {
            filtered = filtered.filter((device) => {
                const deviceDate = new Date(device.purchaseDate);
                const toDate = new Date(searchDeviceDateTo);
                return deviceDate <= toDate;
            });
        }

        setFilteredDevices(filtered);
        setPage(0); // Reset to first page when searching
    };

    // Reset function for device search
    const handleResetDeviceSearch = () => {
        setSearchDeviceDeviceName('');
        setSearchDevicePrice('');
        setSearchDeviceColour('');
        setSearchDeviceShopName('');
        setSearchDeviceModelNumber('');
        setSearchDeviceEmiNumber('');
        setSearchDeviceDateFrom('');
        setSearchDeviceDateTo('');
        setFilteredDevices([]);
        setPage(0);
    };

    const handleSubmit = async (event) => {
        event.preventDefault();

        console.log(form);

        const { emiNumber } = form; // Assuming 'emiNumber' is a key in your form data

        try {
            // Check if EMI number is available in the selling table
            const sellingResponse = await axios.get(`https://app.smartco.live/selling/getbyEmi/${emiNumber}`);

            if (sellingResponse.data.message !== "data not available") {
                alert("This EMI number is already taken in the selling table.");
                return; // Stop the function execution
            } else {
                console.log("EMI number not found in the selling table.");
            }
        } catch (error) {
            console.error("Error checking EMI number in the selling table:", error);
            return; // Stop the function execution if there is a different error
        }

        try {
            // Check if EMI number is available in the device table
            const deviceResponse = await axios.get(`https://app.smartco.live/device/getOneDevicebyemi/${emiNumber}`);

            if (deviceResponse.data.message !== "data not available") {
                alert("This EMI number is already taken in the device table.");
                return; // Stop the function execution
            } else {
                console.log("EMI number not found in the device table.");
            }
        } catch (error) {
            console.error("Error checking EMI number in the device table:", error);
            return; // Stop the function execution if there is a different error
        }

        const formData = new FormData();
        Object.keys(form).forEach(key => {
            formData.append(key, form[key]);
        });
        console.log(formData);

        try {
            // Add device to device table
            await axios.post('https://app.smartco.live/device/addDevice', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            });
            fetchDevices();

            // Add device to inventory table
            const inventoryData = {
                deviceName: form.deviceName,
                price: form.price,
                color: form.color,
                shopName: form.shopName,
                modelNumber: form.modelNumber,
                storage: form.storage,
                ram: form.ram,
                warrenty: form.warrenty,
                emiNumber: form.emiNumber,
                purchaseDate: form.purchaseDate,
            };

            await axios.post('https://app.smartco.live/inventory/addInventory', inventoryData, {
                headers: {
                    'Content-Type': 'application/json'
                }
            });
            alert("New Device added successfully");

        } catch (error) {
            console.error('Error adding devices or inventory:', error);
        }
    };

    return (
        <div>
            <ThemeProvider theme={mdTheme}>
                <Box sx={{ display: 'flex' }}>
                    <CssBaseline />
                    <AppBar sx={{ backgroundColor: 'white', color: '#637381' }} position="absolute" open={open}>
                        <Toolbar sx={{ pr: '24px' }}>
                            <IconButton
                                edge="start"
                                color="inherit"
                                aria-label="open drawer"
                                onClick={toggleDrawer}
                                sx={{
                                    marginRight: '36px',
                                    ...(open && { display: 'none' }),
                                }}
                            >
                                <MenuIcon />
                            </IconButton>
                            <Typography
                                component="h1"
                                variant="h6"
                                noWrap
                                sx={{
                                    flexGrow: 1,
                                    background: 'linear-gradient(90deg, #C63DE7, #752888)',
                                    WebkitBackgroundClip: 'text',
                                    WebkitTextFillColor: 'transparent',
                                    fontFamily: 'Public Sans, sans-serif',
                                    fontWeight: 'bold',
                                }}
                            >
                                SMARTCO
                            </Typography>
                            <IconButton color="inherit" onClick={handleLogout}>
                                <Badge color="secondary">
                                    <LogoutIcon />
                                </Badge>
                            </IconButton>
                        </Toolbar>
                    </AppBar>
                    <Drawer variant="permanent" open={open}>
                        <Toolbar sx={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', px: [1], }}>
                            <IconButton onClick={toggleDrawer}>
                                <ChevronLeftIcon />
                            </IconButton>
                        </Toolbar>
                        <Divider />
                        <List component="nav">
                            {mainListItems}
                            <Divider sx={{ my: 1 }} />
                            {secondaryListItems}
                        </List>
                    </Drawer>
                    <Box
                        component="main"
                        sx={{
                            backgroundColor: (theme) =>
                                theme.palette.mode === 'light'
                                    ? theme.palette.grey[100]
                                    : theme.palette.grey[900],
                            flexGrow: 1,
                            height: '100vh',
                            overflow: 'auto',
                        }}
                    >
                        <Toolbar />
                        <Container>
                            <Box
                                sx={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    alignItems: 'center',
                                    marginTop: 4,
                                    padding: 3,
                                    backgroundColor: '#fff',
                                    borderRadius: 1,
                                    boxShadow: 3,
                                    maxWidth: 500,
                                    width: '100%',
                                    mx: 'auto',
                                }}
                            >
                                <Typography component="h1" variant="h5" gutterBottom sx={{ fontFamily: 'Public Sans, sans-serif', fontWeight: 'bold', color: "#637381" }}>
                                    Device Details
                                </Typography>
                                <Box component="form" sx={{ mt: 1 }} onSubmit={handleSubmit}>
                                    <TextField margin="normal"
                                        required
                                        fullWidth
                                        label="Device Name"
                                        name="deviceName"
                                        value={form.deviceName}
                                        onChange={handleInputChange} />
                                    <TextField margin="normal"
                                        required
                                        fullWidth
                                        label="Price"
                                        name="price"
                                        value={form.price}
                                        onChange={handleInputChange} />
                                    <TextField margin="normal"
                                        required
                                        fullWidth
                                        label="Colour"
                                        name="color"
                                        value={form.color}
                                        onChange={handleInputChange} />
                                    <TextField margin="normal"
                                        required
                                        fullWidth
                                        label="Shop Name"
                                        name="shopName"
                                        value={form.shopName}
                                        onChange={handleInputChange} />
                                    <TextField margin="normal"
                                        required
                                        fullWidth
                                        label="Model Number"
                                        name="modelNumber"
                                        value={form.modelNumber}
                                        onChange={handleInputChange} />
                                    <TextField margin="normal"
                                        required
                                        fullWidth
                                        label="Storage"
                                        name="storage"
                                        value={form.storage}
                                        onChange={handleInputChange} />
                                    <TextField margin="normal"
                                        required
                                        fullWidth
                                        label="Ram"
                                        name="ram"
                                        value={form.ram}
                                        onChange={handleInputChange} />
                                    <TextField margin="normal"
                                        required
                                        fullWidth
                                        label="Warrenty"
                                        name="warrenty"
                                        value={form.warrenty}
                                        onChange={handleInputChange} />
                                    <TextField margin="normal"
                                        required
                                        fullWidth
                                        label="EMI Number"
                                        name="emiNumber"
                                        value={form.emiNumber}
                                        onChange={handleInputChange} />
                                    <TextField margin="normal"
                                        required
                                        fullWidth
                                        label="Purchase Date"
                                        type="date"
                                        name="purchaseDate"
                                        value={form.purchaseDate}
                                        onChange={handleInputChange} />
                                    <TextField
                                        margin="normal"
                                        required
                                        fullWidth
                                        type="file"
                                        name="imageName"
                                        onChange={handleFileChange}
                                    />
                                    <Button
                                        type="submit"
                                        fullWidth
                                        variant="contained"
                                        sx={{
                                            mt: 3,
                                            mb: 2,
                                            backgroundColor: '#752888',
                                            '&:hover': {
                                                backgroundColor: '#C63DE7',
                                            },
                                            fontFamily: 'Public Sans, sans-serif',
                                            fontWeight: 'bold',
                                        }}
                                    >
                                        Submit
                                    </Button>
                                </Box>
                            </Box>
                            {/* Search Section for Devices */}
                            <Box
                                sx={{
                                    marginTop: 4,
                                    padding: 3,
                                    backgroundColor: "#fff",
                                    borderRadius: 1,
                                    boxShadow: 3,
                                    maxWidth: 1200,
                                    width: "100%",
                                    mx: "auto",
                                }}
                            >
                                <Typography
                                    component="h1"
                                    variant="h5"
                                    gutterBottom
                                    sx={{
                                        fontFamily: "Public Sans, sans-serif",
                                        fontWeight: "bold",
                                        color: "#637381",
                                    }}
                                >
                                    Search Device Records
                                </Typography>
                                <Box sx={{ mt: 2, display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: 2 }}>
                                    <TextField
                                        label="Device Name"
                                        value={searchDeviceDeviceName}
                                        onChange={(e) => setSearchDeviceDeviceName(e.target.value)}
                                        fullWidth
                                    />
                                    <TextField
                                        label="Price"
                                        value={searchDevicePrice}
                                        onChange={(e) => setSearchDevicePrice(e.target.value)}
                                        fullWidth
                                    />
                                    <TextField
                                        label="Colour"
                                        value={searchDeviceColour}
                                        onChange={(e) => setSearchDeviceColour(e.target.value)}
                                        fullWidth
                                    />
                                    <TextField
                                        label="Shop Name"
                                        value={searchDeviceShopName}
                                        onChange={(e) => setSearchDeviceShopName(e.target.value)}
                                        fullWidth
                                    />
                                    <TextField
                                        label="Model Number"
                                        value={searchDeviceModelNumber}
                                        onChange={(e) => setSearchDeviceModelNumber(e.target.value)}
                                        fullWidth
                                    />
                                    <TextField
                                        label="EMI Number"
                                        value={searchDeviceEmiNumber}
                                        onChange={(e) => setSearchDeviceEmiNumber(e.target.value)}
                                        fullWidth
                                    />
                                    <TextField
                                        label="Purchase Date From"
                                        type="date"
                                        value={searchDeviceDateFrom}
                                        onChange={(e) => setSearchDeviceDateFrom(e.target.value)}
                                        InputLabelProps={{ shrink: true }}
                                        fullWidth
                                    />
                                    <TextField
                                        label="Purchase Date To"
                                        type="date"
                                        value={searchDeviceDateTo}
                                        onChange={(e) => setSearchDeviceDateTo(e.target.value)}
                                        InputLabelProps={{ shrink: true }}
                                        fullWidth
                                    />
                                </Box>
                                <Box sx={{ mt: 3, display: 'flex', gap: 2 }}>
                                    <Button
                                        variant="contained"
                                        onClick={handleSearchDevices}
                                        sx={{
                                            backgroundColor: "#752888",
                                            "&:hover": {
                                                backgroundColor: "#C63DE7",
                                            },
                                            fontFamily: "Public Sans, sans-serif",
                                            fontWeight: "bold",
                                        }}
                                    >
                                        Fetch Data
                                    </Button>
                                    <Button
                                        variant="contained"
                                        onClick={handleResetDeviceSearch}
                                        sx={{
                                            backgroundColor: "#637381",
                                            "&:hover": {
                                                backgroundColor: "#7f8c8d",
                                            },
                                            fontFamily: "Public Sans, sans-serif",
                                            fontWeight: "bold",
                                        }}
                                    >
                                        Reset
                                    </Button>
                                </Box>
                            </Box>

                            {/* Table Section */}
                            <Box sx={{
                                mt: 6,
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center',
                                marginTop: 4,
                                padding: 3,
                                backgroundColor: '#fff',
                                borderRadius: 1,
                                boxShadow: 3,
                                maxWidth: 1500, // Adjust this value as needed
                                flexGrow: 1,
                                mx: 'auto',
                            }}>
                                <TableContainer component={Paper}>
                                    <Table sx={{ minWidth: 650 }}>
                                        <TableHead>
                                            <TableRow>
                                                <TableCell style={{ backgroundColor: '#752888', color: 'white' }} >Device Name</TableCell>
                                                <TableCell style={{ backgroundColor: '#752888', color: 'white' }} >Price</TableCell>
                                                <TableCell style={{ backgroundColor: '#752888', color: 'white' }} >Colour</TableCell>
                                                <TableCell style={{ backgroundColor: '#752888', color: 'white' }} >Shop Name</TableCell>
                                                <TableCell style={{ backgroundColor: '#752888', color: 'white' }} >Model Number</TableCell>
                                                <TableCell style={{ backgroundColor: '#752888', color: 'white' }} >Storage</TableCell>
                                                <TableCell style={{ backgroundColor: '#752888', color: 'white' }} >Ram</TableCell>
                                                <TableCell style={{ backgroundColor: '#752888', color: 'white' }} >Warrenty</TableCell>
                                                <TableCell style={{ backgroundColor: '#752888', color: 'white' }} >Emi Number</TableCell>
                                                <TableCell style={{ backgroundColor: '#752888', color: 'white' }} >Purchase Date</TableCell>
                                                <TableCell style={{ backgroundColor: '#752888', color: 'white' }} >Image Name</TableCell>
                                                {user?.role !== "employee" && (
                                                    <TableCell style={{ backgroundColor: '#752888', color: 'white' }}>
                                                        Action
                                                    </TableCell>
                                                )}
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {(filteredDevices.length > 0 ? filteredDevices : devices)
                                                .slice()
                                                .reverse()
                                                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                                .map((device) => (
                                                    <TableRow key={device._id}>
                                                        <TableCell>{device.deviceName}</TableCell>
                                                        <TableCell>{device.price}</TableCell>
                                                        <TableCell>{device.color}</TableCell>
                                                        <TableCell>{device.shopName}</TableCell>
                                                        <TableCell>{device.modelNumber}</TableCell>
                                                        <TableCell>{device.storage}</TableCell>
                                                        <TableCell>{device.ram}</TableCell>
                                                        <TableCell>{device.warrenty}</TableCell>
                                                        <TableCell>{device.emiNumber}</TableCell>
                                                        <TableCell>{device.purchaseDate}</TableCell>
                                                        <TableCell>
                                                            {device.imageName && (
                                                                <img
                                                                    src={`${device.imageName}`}
                                                                    alt={device.deviceName}
                                                                    style={{ width: '100px', height: '100px' }}
                                                                />
                                                            )}
                                                        </TableCell>
                                                        {user?.role !== "employee" && (
                                                            <TableCell>
                                                                <Link to={`eupdatedevice/${device.emiNumber}`}>
                                                                    <IconButton color="primary">
                                                                        <EditIcon />
                                                                    </IconButton>
                                                                </Link>

                                                                <IconButton
                                                                    color="secondary"
                                                                    onClick={() => handleDelete(device._id, device.emiNumber)}
                                                                >
                                                                    <DeleteIcon />
                                                                </IconButton>
                                                            </TableCell>
                                                        )}

                                                    </TableRow>
                                                ))}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                                <Box
                                    sx={{
                                        display: 'flex',
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                        mt: 2,
                                        pb: 2,
                                        borderTop: '1px solid #e0e0e0',
                                        backgroundColor: '#fafafa',
                                    }}
                                >
                                    <TablePagination
                                        rowsPerPageOptions={[5, 10, 25, 50]}
                                        component="div"
                                        count={filteredDevices.length > 0 ? filteredDevices.length : devices.length}
                                        rowsPerPage={rowsPerPage}
                                        page={page}
                                        onPageChange={handleChangePage}
                                        onRowsPerPageChange={handleChangeRowsPerPage}
                                        sx={{
                                            width: '100%',
                                            '& .MuiTablePagination-toolbar': {
                                                flexWrap: 'wrap',
                                                justifyContent: 'center',
                                                padding: { xs: '8px', sm: '16px' },
                                            },
                                            '& .MuiTablePagination-selectLabel, & .MuiTablePagination-displayedRows': {
                                                fontFamily: 'Public Sans, sans-serif',
                                                fontSize: { xs: '0.75rem', sm: '0.875rem' },
                                                color: '#637381',
                                                fontWeight: 500,
                                            },
                                            '& .MuiTablePagination-select': {
                                                fontFamily: 'Public Sans, sans-serif',
                                                backgroundColor: '#fff',
                                                borderRadius: '8px',
                                                padding: '4px 8px',
                                                border: '1px solid #e0e0e0',
                                                '&:hover': {
                                                    backgroundColor: '#f5f5f5',
                                                },
                                            },
                                            '& .MuiTablePagination-actions': {
                                                marginLeft: { xs: '8px', sm: '20px' },
                                                '& .MuiIconButton-root': {
                                                    backgroundColor: '#fff',
                                                    border: '1px solid #e0e0e0',
                                                    borderRadius: '8px',
                                                    padding: '8px',
                                                    margin: '0 4px',
                                                    transition: 'all 0.3s ease',
                                                    '&:hover': {
                                                        backgroundColor: '#752888',
                                                        borderColor: '#752888',
                                                        color: '#fff',
                                                    },
                                                    '&.Mui-disabled': {
                                                        backgroundColor: '#f5f5f5',
                                                        borderColor: '#e0e0e0',
                                                        opacity: 0.5,
                                                    },
                                                },
                                            },
                                        }}
                                    />
                                </Box>
                            </Box>
                        </Container>
                    </Box>
                </Box>
            </ThemeProvider>
        </div>
    )
}
